import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ubaToken: null,
};

export const ubaTokenSlice = createSlice({
  name: "ubaToken",
  initialState,
  reducers: {
    setUbaToken: (state, action) => {
      state.ubaToken = action.payload;
    },
    clearUbaToken: (state) => {
      state.ubaToken = null;
    },
  },
});

export const { setUbaToken, clearUbaToken } = ubaTokenSlice.actions;
export default ubaTokenSlice.reducer;
